export const URLAPISUBIDA = 'https://amevi.com.co/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://amevi.com.co/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://amevi.com.co/notis/'

export const URLAPISUBIDAPDF = 'https://amevi.com.co/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://amevi.com.co/notis/'